import React from 'react';
import { TrailBlazerWinners2026 } from '../views';


const TheNPSFamilyPage = () => {
  return <TrailBlazerWinners2026/>;
};

export default TheNPSFamilyPage;